<template>
  <Card :headerStyle="{background: '#d4d5d5'}" dis-hover class="discounts am-margin-bottom-sm">
    <div class="am-cf" slot="title">
      <h2>
        优惠活动
      </h2>
    </div>
    <div slot="extra" style="transform: translateY(-25%)">
      <Button @click.native="card.visible = !card.visible" type="info" :disabled="isAmend">优惠卡</Button>
      <Button class="am-margin-left-sm" @click.native="discountsModal" v-if="store.isSupportDiscount"
              :disabled="!isAddCart">手动打折
      </Button>
    </div>
    <div class="form-item" v-show="card.visible">
      <div class="form-item-label">输入卡号：</div>
      <div class="form-item-content">
        <Input type="text" v-model.trim="card.number" @on-blur="handleValidateCard" :disabled="isAmend"/>
      </div>
      <div class="form-item-content am-padding-left-xs" v-show="!isAmend">
        <Button @click.native="handleSubmitCard" :loading="card.loading">确定</Button>
      </div>
      <div class="form-item-content am-padding-left-xs">
        <span :class="{'discounts-card-error': card.error}" v-show="card.error">
          {{card.errorText}}
        </span>
        <span class="discounts-card-success">
          {{card.msg}}
        </span>
      </div>
    </div>
    <ul class="discounts-list">
      <!--优惠活动-->
      <li class="discounts-item am-padding-bottom-xs" v-for="(chunk, index) in promotions" :key="index">
        <div class="discounts-item-title">
          <span>{{index+1}}、{{chunk.title}}</span>
          <span class="discounts-reject am-padding-left-sm" v-show="!chunk.isAccord">[未达到优惠条件]</span>
        </div>
        <div class="am-padding-left-sm">
          <Button v-for="(item, key) in chunk.items" :key="key" :disabled="isAmend"
                  class="am-margin-right-xs am-margin-vertical-xs discounts-item-button"
                  @click.native="checkPromotionsType(chunk,item)" :class="{active: item.isSelect}">{{item.content}}
          </Button>
        </div>
      </li>
    </ul>
    <div class="discounts-action-list" v-if="manualPreferentials.length>0">
      <div class="discounts-action-title">
        手动打折
      </div>
      <div class="am-padding-left-sm">
        <p class="discounts-action-item" v-for="item in manualPreferentials" :key="item._key">
          {{item.content}}
        </p>
      </div>
    </div>
    <div class="discounts-price">
      <span class="am-padding-right-sm">总优惠金额：{{currency}}{{subtractAmount}}</span>
      <span class="am-padding-right-sm">满加：{{currency}}{{raisePriceTotal}}</span>
      <span class="discount-pay-price">顾客需付: {{currency}}{{total | formatPrice(true)}}(已含优惠)</span>
    </div>
    <cc-loading-box class="loading-box" :isLoading="isLoading"></cc-loading-box>
    <!--手动打折-->
    <Modal v-model="service.visible" width="850px">
      <div slot="header">手动打折</div>
      <div class="service am-g-collapse">
        <CheckboxGroup v-model="service.type" @on-change="handleCheckBoxGroup(service.type)">
          <div class="service-pane">
            <div class="am-g">
              <div class="am-u-sm-3">
                <Checkbox :label="0">全单打折</Checkbox>
              </div>
              <div class="u-sm-9">
                <!--全单打折-->
                <RadioGroup v-model="service.allProduct.checkValue">
                  <Radio :label="2" :disabled="service.allProduct.disabled">
                    <span slot-scope="{ currentValue }">
                       折扣设置<InputQuantity prepend append size="small" class="service-input" :max="99"
                                          v-model="service.allProduct.fold"
                                          :disabled="service.allProduct.disabled|| !currentValue"
                    ></InputQuantity>%
                    </span>
                  </Radio>
                  <Radio class="am-padding-left-sm" :label="4" :disabled="service.allProduct.disabled">
                    <span slot-scope="{ currentValue }">
                     <span>减免金额{{currency}}</span>
                    <Input size="small" class="service-input" v-model="service.allProduct.sum" number
                           @on-blur="handleValidateService(service.allProduct)"
                           :disabled="service.allProduct.disabled || !currentValue"/>
                    </span>
                  </Radio>
                </RadioGroup>
              </div>
            </div>
          </div>
          <div class="service-pane">
            <Checkbox :label="1">餐品打折</Checkbox>
          </div>
          <!--餐品打折-->
          <div class="service-pane-content am-text-center am-scroll" v-show="service.show">
            <template v-if="service.products.length>0">
              <div class="am-g am-margin-bottom-sm">
                <div class="am-u-sm-3">餐品名称</div>
                <div class="am-u-sm-1">小计</div>
                <div class="am-u-sm-1">数量</div>
                <div class="am-u-sm-2">打折份数</div>
                <div class="am-u-sm-5">折扣</div>
              </div>
              <div class="am-g " v-for="(item, index) in service.products" :key="index">
                <template v-if="!item.readonly">
                  <div class="am-u-sm-12 am-margin-bottom-sm">
                    <div class="am-u-sm-3 am-text-left service-product-name">
                      <template v-if="item.type === 2 || item.isRequirement">
                      <span class="service-triangle-contain " @click="item._discount.show = !item._discount.show "><span
                        class="service-triangle" :class="{expand: item._discount.show }"></span></span>
                      </template>
                      <span>{{item.name}}</span>
                    </div>
                    <div class="am-u-sm-1 ">{{item.totalProductPrice | formatPrice(true) }}</div>
                    <div class="am-u-sm-1">{{item.num}}</div>
                    <div class="am-u-sm-2">
                      <InputQuantity prepend append size="small" class="service-input" :max="item.num"
                                     v-model="item._discount.num" :min="0"
                      ></InputQuantity>
                    </div>
                    <!--设置-->
                    <div class="am-u-sm-5 ">
                      <RadioGroup v-model="item._discount.checkValue">
                        <div class="am-cf">
                          <div class="am-fl">
                            <Radio :label="1" :disabled="item._discount.num<=0">
                            <span slot-scope="{ currentValue }">
                              折扣设置<InputQuantity :max="99" min="0" prepend append size="small" class="service-input"
                                                 v-model="item._discount.fold"
                                                 :disabled="item._discount.num<=0 || !currentValue"></InputQuantity>%
                            </span>
                            </Radio>
                          </div>
                          <div class="am-fr">
                            <Radio :label="3" :disabled="item._discount.num<=0">
                            <span slot-scope="{ currentValue }">
                              <span>减免金额{{currency}}</span>
                            <Input size="small" class="service-input" v-model="item._discount.sum"
                                   :disabled="item._discount.num<=0 || !currentValue" number
                                   @on-blur="handleValidateService(item._discount)"/>
                            </span>
                            </Radio>
                          </div>
                        </div>
                      </RadioGroup>
                    </div>
                  </div>
                  <!--套餐-->
                  <div v-show="item._discount.show " class="">
                    <template v-if="item.isRequirement">
                      <div class="am-u-sm-12">
                        <span class="am-fl am-padding-left-sm">特殊要求：</span>
                        <span class="am-fl">
                      <span v-for="(text, index) in item.desc" :key="index" class="am-padding-left-sm">
                        {{text}}
                      </span>
                    </span>
                      </div>
                    </template>
                    <template v-else-if="item.type === 2">
                      <div class="am-u-sm-12  am-margin-bottom-sm" v-for="(product, index) in item.products"
                           :key="index">
                        <div class="am-u-sm-4 am-text-left"><span class="am-padding-left-sm">{{product.name}} </span>
                        </div>
                        <div class="am-u-sm-1 am-text-center am-u-end">{{product.num}}</div>
                        <div class="am-u-sm-12 am-padding-top-sm" v-if="product.desc">
                          <span class="am-fl am-padding-left-sm">特殊要求：</span>
                          <div class="am-fl">
                            <span v-for="(text, index) in product.desc" :key="index"
                                  class="am-padding-left-sm">{{text}}</span>
                          </div>
                        </div>
                      </div>
                    </template>
                  </div>
                </template>
              </div>
            </template>
            <template v-else>
              没有符合打折的餐品
            </template>
          </div>
        </CheckboxGroup>
      </div>
      <div slot="footer" class="am-text-right">
        <Button @click.native="saveDiscountsService">保存</Button>
        <Button @click.native="service.visible=false" class="am-btn-cancel">取消</Button>
      </div>
    </Modal>
  </Card>
</template>

<script>
  import {mapState} from 'vuex'
  import {oneOf, deepClone, each, throttle, find, formatPrice} from '@/utils/assist'
  import Card from '@/components/Card/index'
  import Button from '@/components/Button/index'
  import emitter from '@/components/emitter'
  import Input from '@/components/Input/index'
  import InputQuantity from '@/components/InputQuantity/index'
  import Radio from '@/components/Radio/index'
  import RadioGroup from '@/components/RadioGroup/index'
  import CheckboxGroup from '@/components/CheckboxGroup/index'
  import Checkbox from '@/components/Checkbox/index'
  import Modal from '@/components/Modal'
  import LoadingBox from '@/components/Cc-Loading'
  import lib from '@/lib/server'

  const initData = {
    isFirst: true,
    isLoading: false,
    service: { // 手动打折
      visible: false,
      type: [],
      allProduct: {
        checkValue: 0, sum: 0, fold: 99, disabled: true
      },
      products: [],
      show: false
    },
    tree: {},  // 优惠活动对象
    card: { // 优惠卡对象
      visible: false,
      number: null,
      error: false,
      errorText: null,
      loading: false,
      msg: '',
      amount: 0,
      type: null
    }
  };
  export default {
    inject: ['products'],
    props: {
      deliveryFee: {
        type: Number
      },
      isAmend: {
        type: Boolean
      },
      isAddCart: { // 是否可以添进购物车
        type: Boolean
      }
    },
    mixins: [emitter],
    name: 'Discounts',
    created() {
      // 订阅更新事件
      this.$on('order-update', (o) => {
        this.init(o)
      })
    },
    filters: {
      formatPrice
    },
    data() {
      return {
        currency: window.currency,
        ...deepClone(initData)
      }
    },
    mounted() {
      console.log('Discount.vue mounted...');
    },
    computed: {
      subtractAmount() {
        // 优惠金额
        let {cart, total} = this, {fee} = cart, sum = fee.products + fee.delivery + fee.mealFee;
        return formatPrice(sum - total > 0 ? sum - total : 0,true)
      },
      total() {
        // 需支付金额
        let {cart, delivery, card} = this,
          {fee} = cart,
          {type, amount} = card,
          {products, total} = fee,
          money;
        type *= 1;
        amount *= 1;
        if (type) {
          // 优惠卡 type 1 减产品 2 减免派送
          money = type === 1 ? products + amount : delivery + amount;
          money = money < 0 ? 0 : money;
          total -= type === 1 ? products : delivery;
          total += money
        }
        total = formatPrice(total + delivery - fee.delivery);
        total = total > 0 ? total : 0;
        this.$store.commit('booking/preferential/updateData', {
          total
        });
        return total
      },
      delivery() {
        // 配送费 区分业务展示
        let preDeliveryPrice = this.preDeliveryPrice, delivery = this.deliveryFee;
        delivery = formatPrice(preDeliveryPrice + delivery);
        return delivery > 0 ? delivery : 0
      },
      raisePriceTotal() {
        //  优惠活动满加金额
        let sum = 0, list = this.preferential.list;
        each(list, (value) => {
          if (value.type === 2) sum += value.price
        });
        return formatPrice(sum,true)
      },
      ...mapState({
        cart: state => state.booking.cart,
        user: state => state.booking.user,
        storeId: state => state.booking.user.storeId,
        store: state => state.booking.store.data,
        preferential: state => state.booking.preferential,
        promotions: state => state.booking.preferential.data,
        cardNum: state => state.booking.preferential.cardNum,
        discountProducts: state => state.booking.preferential.discountProducts,
        pres: state => state.booking.preferential.pres,
        manualPreferentials: state => state.booking.preferential.manualPreferentials,
        preDeliveryPrice: state => state.booking.preferential.preDeliveryPrice,
        orderType: state => state.booking.user.sendType,
        products: state => state.booking.menu.data.products,
        menuId: state => state.booking.menu.data.menuId,
        selfGetTime: state => state.booking.user.reserveDate
      })
    },
    methods: {
      init({isStore, isClear, isAmend}) {
        let {cardNum, card} = this;
        console.log(arguments);
        if (isClear) {
          // 清除vuex的优惠数据
          this.$store.dispatch('booking/preferential/clear', {
            manualPreferentials: []
          });
          try {
            if (!isAmend&&Object.keys(this.tree).length === 0) this.getStorePromotions();
          } catch (error) {
            console.error(error)
          }
          // 初始化组件Data数据
          return each(deepClone(initData), (value, key) => {
            if (key && key !== 'tree') {
              this[key] = value;
            }
          });
        }
        if (isStore) {
          // 门店切换 重新拉取门店优惠活动 清除vuex的优惠活动
          this.tree = {};
          this.getStorePromotions();
          this.$store.dispatch('booking/preferential/clear', {
            manualPreferentials: []
          })
        }
        if (!isAmend) this.getStoreUsableCoupon(); // 获取用户可用门店优惠
        if (cardNum) {
          // 存在优惠号码, 清除之前的优惠,重新去请求卡卷
          this.clearDiscountsCard();
          card.visible = true;
          card.number = cardNum;
          this.handleSubmitCard()
        }
      },
      throttle: throttle(),
      clearDiscountsService() {
        // 清除手动打折
        this.service = {...deepClone(initData.service)};
        // 清除购物车的打折费用
        this.$store.dispatch('booking/cart/updateFee', {manualDiscount: 0});
        // 清除优惠保存的项目
        this.$store.commit('booking/preferential/updateData', {
          manualPreferentials: []
        })
      },
      getTotalFee() {
        // 可以进行手动打折的总费用
        let total = this.total;
        total -= (this.cart.fee.manualDiscount || 0);
        return formatPrice(total)
      },
      clearDiscountsCard() {
        // 清除优惠卡
        let {card} = this;
        Object.assign(card,
          {...initData.card, visible: card.visible});
        this.$store.commit('booking/preferential/updateData', {
          cardNum: null,
          cardMsg: null
        });
      },
      handleValidateCard() {
        // 验证优惠卡格式
        let {card} = this,
          number = card.number;
        if (!/^[0-9A-Za-z]{6,20}$/.test(number)) {
          card.error = true
          card.errorText = number ? '优惠卡有误，请重新输入' : '请输入优惠卡号'
        } else {
          card.error = false
        }
      },
      handleSubmitCard() {
        //提交优惠卡 type 1 减产品 2 减免派送
        this.handleValidateCard();
        let {card, storeId, orderType, selfGetTime} = this,
          {number, error, loading} = card;
        if (loading || error) return;
        card.loading = true;
        this.server.get({
          name: 'getCanUseGiftCardByCode',
          data: {
            storeId,
            orderType,
            code: number,
            appointmentTime: selfGetTime || '',
            isIntercept: true
          }
        }).then((res) => {
          let data = res.data,
            msg = '';
          if (res.status !== 1 || !data.isCanUseCode) {
            card.error = true;
            card.errorText = res.msg;
            return
          }
          let coupon = data.coupon,
            type = coupon.reliefType,
            offsetMoney = coupon.offsetMoney;
          if (type === 1) msg = `减免餐品费${currency}${offsetMoney}`;
          else msg = `减免配送费${currency}${offsetMoney}`;
          card.type = type;
          card.amount = offsetMoney * -1;
          card.msg = msg;
          this.$store.commit('booking/preferential/updateData', {
            cardNum: number,
            cardMsg: msg
          })
        }).finally(() => {
          card.loading = false
        })
      },
      handleCheckBoxGroup(checkValue) {
        //勾选手动打折
        this.service.allProduct.disabled = checkValue.indexOf(0) === -1;
        this.service.show = checkValue.indexOf(1) > -1
      },
      handleValidateService(discount) {
        //对减免的金额进行验证
        let {maxSum, sum} = discount;
        if (/^[0-9]+(.[0-9]+)?$/.test(sum)) {
          sum = formatPrice(sum);
          if (sum > maxSum) {
            sum = maxSum;
            this.$Modal.error({
              title: '提示',
              content: `减免金额不得大于${sum}`
            });
            discount.sum = sum;
            return
          }
        } else {
          sum = 0
        }
        discount.sum = sum
      },
      discountsModal() {
        // 初始化手动打折 service手动打折对象 products 购物车产品 discountProducts享受打折的产品  manualPreferentials已经存在的手动打折
        let total = this.getTotalFee(),
          {service, products, discountProducts, manualPreferentials} = this,
          forbidProducts = {},
          list = [],
          type = [],
          productObj = {},
          show = false,
          allProductObj = {
            checkValue: 2, sum: 0, fold: 99, key: 0, uid: 0, maxSum: total, disabled: true
          };
        each(manualPreferentials, (value) => {
          // 手动打折的数据复原
          let {_discount} = value;
          if (_discount) {
            let {key} = _discount;
            productObj[key] = {..._discount}
          } else {
            // 全单打折
            productObj[0] = {
              checkValue: value.type,
              sum: value.redPrice,
              fold: value.rate,
              key: 0,
              uid: 0,
              maxSum: value.maxSum,
              disabled: false
            }
          }
        });
        // 优惠产品的数据
        each(discountProducts, (value) => forbidProducts[value.pid] = true);
        each(products, (value) => {
          // 对餐品打折进行初始化
          let {_key, _index = 0, num, totalProductPrice} = value,
            key = _index ? _key + _index : _key,
            uid = _key.split('-').pop();
          if (forbidProducts[uid]) return;
          let _discount = {
            checkValue: 1,
            num: 0,
            sum: 0,
            fold: 99,
            show: false,
            key,
            uid,
            maxSum: formatPrice(totalProductPrice / num),
            _key,
            totalProductPrice,
            maxNum: num
          };
          value._discount = productObj[key] ? productObj[key] : _discount;
          list.push({...value})
        });
        // 初始化全单打折和餐品打折
        if (productObj[0]) {
          type.push(0);
          allProductObj = {...productObj[0]}
        }
        //判断打折活动是否在全单打折，全单折扣，以及确定是否有选择餐品折扣进行勾选
        if ((manualPreferentials.length > 1 && productObj[0]) || (!productObj[0] && manualPreferentials.length > 0)) {
          show = true;
          type.push(1)
        }
        service.show = show;
        service.type = type;
        service.allProduct = allProductObj;
        service.visible = true;
        service.products = list;
      },
      removeDiscountsService() {
        // 手动打折的自动处理 @param discountProducts 优惠活动的产品
        let total = this.getTotalFee(),
          totalFee = total,
          status = false,
          {discountProducts, products, manualPreferentials} = this,
          forbidProducts = {},
          list = [],
          totalPrice = 0,
          allProduct,
          o = {};
        // forbidProducts收集参加优惠活动的pid
        each(discountProducts, (value) => forbidProducts[value.pid] = true);
        each(products, (value) => {
          let {_key, _index} = value,
            key = _index ? _key + _index : _key;
          o[key] = value
        });
        each(manualPreferentials, (value) => {
          // 对已打折的餐品进行处理
          let {pid} = value;
          if (pid) {
            let {_discount} = value,
              {total, key, totalProductPrice, maxNum} = _discount;
            // 1、享受打折 2、不存在购物车 3、(存在购物车 数量比较或者金额比较) 移除手打打折
            if (forbidProducts[pid] || !o[key] || (o[key] && (maxNum * 1 !== o[key].num * 1 || (o[key].totalProductPrice !== totalProductPrice)))) {
              status = true
            }
            else {
              totalPrice += total * 1;
              list.push({...value})
            }
          } else {
            allProduct = {...value}
          }
        });
        total -= totalPrice;
        // 全单打折处理
        if (allProduct) {
          let state = true,
            {redPrice, rate, type} = allProduct;
          if (type === 4 && redPrice > total) {
            state = false;
            status = true
          }
          if (state) {
            // totalPrice
            allProduct.maxSum = total;
            total -= allProduct.prePrice = (type === 4 ? redPrice : formatPrice(total * (100 - rate) / 100));
            list.unshift({...allProduct})
          }
        }
        if (status) {
          this.$Modal.error({
            title: '提示',
            content: '餐品数据与手动打折数据冲突，系统将删除对应手动打折项'
          })
        }
        this.$store.dispatch('booking/cart/updateFee', {manualDiscount: formatPrice(totalFee - total)});
        this.$store.commit('booking/preferential/updateData', {
          manualPreferentials: list
        })
      },
      calculateDiscountsService() {
        // 计算手动打折
        let total = this.getTotalFee(),
          {service} = this,
          {products, allProduct} = service,
          list = [],
          totalPrice = 0;
        if (oneOf(1, service.type)) {
          //餐品打折处理
          each(products, (value) => {
            let {name, _discount} = value,
              {checkValue, num, sum, fold, maxSum, uid} = _discount, title;
            if (num) {
              let total = 0;
              num *= 1;
              title = _discount.title = checkValue === 3 ? `${name}减${currency}${sum}，限${num}份` : `${name}${(fold / 10).toFixed(1)}折，限${num}份`;
              total += _discount.total = checkValue === 3 ? sum * num : (100 - fold) / 100 * maxSum * num;
              total = formatPrice(total)
              total *= 1;
              totalPrice += total;
              list.push({
                type: checkValue,
                rate: fold,
                redPrice: sum,
                pid: uid,
                count: num,
                prePrice: total,
                content: title,
                _discount: {..._discount}
              })
            }
          });
          total = totalPrice >= total ? 0 : total - totalPrice
        }
        if (oneOf(0, service.type)) {
          // 全单打折处理
          let title, prePrice,
            {checkValue, sum, fold, uid, maxSum} = allProduct;
          if (checkValue && sum > total) {
            let maxSum = allProduct.maxSum = formatPrice(total);
            allProduct.sum = maxSum;
            return {error: `全免单最多只能减免${maxSum}`}
          }
          total -= prePrice = checkValue === 4 ? sum : formatPrice(total * (100 - fold) / 100);
          title = allProduct.title = checkValue === 4 ? `全单减免${currency}${sum}` : `全单折扣${(fold / 10).toFixed(1)}折`;
          list.unshift({
            type: checkValue,
            rate: fold,
            redPrice: sum,
            pid: uid,
            count: 0,
            prePrice: prePrice,
            content: title,
            maxSum
          })
        }
        return {list, total}
      },
      saveDiscountsService() {
        //保存手动打折
        let totalFee = this.getTotalFee(),
          {service} = this,
          {error, list, total} = this.calculateDiscountsService();
        if (error) {
          this.$Modal.error({
            title: '提示',
            content: error
          });
          return
        }
        service.visible = false;
        this.$store.dispatch('booking/cart/updateFee', {manualDiscount: formatPrice(totalFee - total)});
        this.$store.commit('booking/preferential/updateData', {
          manualPreferentials: list
        })
      },
      getStorePromotions() {//获取门店优惠活动
        let {storeId, isLoading} = this;
        if (isLoading) return;
        this.isLoading = true;
        return this.server
          .get({
            name: "getStorePres",
            data: {
              storeId
            }
          })
          .then(res => {
            this.$store.dispatch('booking/preferential/init', res.data).then((res) => {
              this.tree = res;
            })
          }).finally(() => {
            this.isLoading = false
          })
      },
      checkPromotionsType(pre, item) {
        // params pre当前优惠项 item 对应优惠项的子项
        let {isCompatible, isAccord, pid, sendProductRelation} = pre,
          {promotions} = this,
          pres = deepClone(this.pres),
          sum = 0,
          {isSelect, index, num} = item,
          currentPres = pres[pid] = pres[pid] || {},
          isCompatibility = false;
        //不符合要求直接抛弃
        if (!isAccord) return;
        if (isSelect) {
          // 取消选中状态处理 sendProductRelation送全部的直接清除pre,单送的清除item
          if (sendProductRelation) delete pres[pid];
          else delete currentPres[index]
        } else {
          // 对是餐品的进行判断
          if (item.pid) {
            let msg = this.isDisabled(item);
            if (msg) {
              this.$Modal.error({
                title: '提示',
                content: msg
              });
              return
            }
          }
          // 兼容
          if (isCompatible) {
            each(promotions, (value) => {
              let id = value.pid;
              if (pid !== id && pres[id] && !value.isCompatible) {
                isCompatibility = true;
                //删除选中的不兼容
                delete pres[id]
              }
            })
          } else {
            each(pres, () => sum++);
            if (sum > 1) isCompatibility = true;
            //直接清除所有
            pres = {[pid]: currentPres}
          }
          if (sendProductRelation) {
            //为其他能享受选中的选上
            each(pre.items, (value) => {
              if (value.canPre && !this.isDisabled(value)) currentPres[value.index] = value.num
            })
          } else {
            pres[pid] = {[index]: num}
          }
        }
        // 不兼容提示
        if (isCompatibility) {
          this.$Modal.confirm({
            title: '提示',
            content: '当前活动与其他活动不能同时享受，是否继续?',
            okText: '确定',
            cancelText: '取消',
            onOk: () => {
              this.$store.commit('booking/preferential/updateData', {pres});
              this.getStoreUsableCoupon()
            }
          });
          return
        }
        this.$store.commit('booking/preferential/updateData', {pres});
        this.getStoreUsableCoupon()
      },
      disposePromotions(data) {
        // 对可用的优惠的数据处理 promotions门店所有优惠活动 aftPrePrice优惠活动后的金额 pres拥有的优惠活动 discountProducts优惠产品 tree记忆
        let {tree} = this,
          {aftPrePrice, preDeliveryPrice} = data,
          promotions = deepClone(this.$store.state.booking.preferential.cloneData),
          pres = {},
          discountProducts = [], o = [], list = [];
        each(data.pres, (value) => {
          let {pid, type, childType, pids} = value,
            i = 0,
            index = tree[pid],
            o = {},
            isSelect = false;
          promotions[index].sendProductRelation = value.sendProductRelation;
          each(value.items, (value) => {
            let key = [pid, value.index].join('-'), keys = tree[key].split('-');
            if (value.canPre) i++;
            if (value.isSelect) {
              isSelect = true;
              o[value.index] = value.num;
              if (type === 4 && (childType === 7 || childType === 8)) {
                // 折扣产品
                let product = value;
                if (!value.pid && pids.length > 0) product = {pid: pids[0]};
                discountProducts.push(product)
              }
              list.push({...value, type, childType})
            }
            if (keys) {
              let a = keys[0], b = keys[1], target = promotions[a].items[b];
              promotions[a].items[b] = {
                ...target, ...value
              }
            }
          });
          if (isSelect) pres[pid] = o;
          promotions[index].canSelectNum = i;
          promotions[index].isAccord = true
        });
        each(promotions, (value) => o.push(value));
        this.$store.dispatch('booking/preferential/update', {
          list,
          data: o,
          pres,
          aftPrePrice,
          discountProducts,
          preDeliveryPrice
        }).then(() => {
          this.removeDiscountsService()
        })
      },
      getStoreUsableCoupon() {
        //获取用户可用门店优惠
        let {storeId, menuId, orderType, selfGetTime, tree, promotions, preferential, cart, isFirst, pres, isAmend} = this,
          user = this.user.data,
          secretKey = user.secretKey,
          price = cart.fee.products,
          requestList = this.server.requestList,
          cancelList = requestList[lib['getCanPreList']],
          products = cart._products; //数组
        if (cancelList && cancelList.length > 0) { // 取消延迟请求的优惠
          each(cancelList, value => {
            value && value.fn();
          })
        }
        if (products.length === 0) {
          // 购物车没有产品的时候清空一切所有优惠活动
          this.$store.dispatch('booking/preferential/clear', {aftPrePrice: price}).then(() => {
            this.removeDiscountsService()
          });
          return
        }
        // 存在满加的情况 isfirst = false
        if (!isFirst && find(pres, (value, key) => {
          let index = tree[key];
          value = promotions[index];
          return value.type === 2
        })) {
          isFirst = false
        } else if (preferential.list.length === 0) {
          isFirst = true
        }
        this.isLoading = true;
        this.server
          .get({
            name: "getCanPreList",
            data: {
              storeId,
              secretKey,
              products,
              price,
              payType: 1,
              orderType,
              isFirst,
              pres,
              selfGetTime: selfGetTime,
              menuId
            }
          })
          .then(res => {
            // 处理选中优惠
            if (!isAmend && res) this.disposePromotions(res.data)
          }).finally(() => {
          this.isFirst = false;
          this.isLoading = false
        })
      },
      isDisabled(item) {
        let {isInServiceTime, hasInventory, isSoldOut, num, inventoryNum} = item, msg;
        if (!isInServiceTime) {
          msg = '该餐品不在供应时间'
        } else if (isSoldOut) {
          msg = '该餐品已经售罄'
        } else if (hasInventory) {
          if (num > inventoryNum) msg = '该餐品库存不足'
        }
        return msg
      }
    },
    components: {
      Card,
      Button,
      Modal,
      Radio,
      RadioGroup,
      Checkbox,
      CheckboxGroup,
      InputQuantity,
      Input,
      ccLoadingBox: LoadingBox
    },
    watch: {
      'cart._products'(n, o) {
        let isAmend = this.isAmend;
        if (n === o || isAmend) return; // 修改订单状态，不能使用优惠
        //节流
        this.throttle({
          callback: this.getStoreUsableCoupon,
          delay: 800
        })
      },
      'card.visible'(n, o) {
        if (!n) this.clearDiscountsCard(); // 清除优惠卡
      }
    },
    destroyed() {
    }
  }
</script>

<style lang="less" scoped>
  .discounts {
    position: relative;
    z-index: 1;
    .discounts-item-button {
      background: #76869d;
      &.active {
        border-color: #ff823f;
        background: #ff823f;
      }
      &:disabled {
        background-color: inherit;
      }
    }
    .discounts-card-error {
      color: #f47e5a;
    }
    .discounts-card-success {
      color: #FF6600;
    }
    .discount-pay-price {
      color: #e58169;
    }
    .discounts-reject {
      color: #f47e5a;
    }
    .discounts-price {
      font-weight: bold;
    }
    .discounts-action-title {
      font-weight: 800;
    }
    .discounts-action-item {
      margin: 5px 0;
    }
  }

  .service {
    color: rgb(102, 102, 102);
    .service-pane {
      padding: 10px 5px;
      background: rgb(219, 225, 232);
      margin-bottom: 10px;
    }
    .service-pane-content {
      max-height: 400px;
      font-size: 14px;
    }
    .service-input {
      margin: 0 5px;
      width: 50px;
    }
    .service-product-name {
      display: flex;
      font-weight: 600;
    }
    .service-triangle-contain {
      cursor: pointer;
      position: relative;
      width: 20px;
    }
    .service-triangle {
      position: absolute;
      width: 0;
      height: 0;
      border-width: 0 7px 8px 7px;
      border-style: solid;
      border-color: transparent transparent #ccc; /*透明 透明  灰*/
      top: 50%;
      margin-top: -4px;
      left: 0;
      transition: transform .5s;
    }
    .service-triangle.expand {
      transform: rotate(180deg);
    }
  }
</style>



// WEBPACK FOOTER //
// components/pages/order/Discounts/Discounts.vue